'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const SubmissionChart = dynamic(() => import('./SubmissionChart'), { ssr: false });
const CategoryChart = dynamic(() => import('./CategoryChart'), { ssr: false });

export default function AdminCharts() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-5 gap-6 mb-8">
      <div className="xl:col-span-3 bg-card border border-border rounded-2xl p-6 shadow-sm">
        <h3 className="font-bold text-foreground mb-1">Chismes Recibidos por Día</h3>
        <p className="text-xs text-muted-foreground mb-5">Últimos 14 días</p>
        <SubmissionChart />
      </div>
      <div className="xl:col-span-2 bg-card border border-border rounded-2xl p-6 shadow-sm">
        <h3 className="font-bold text-foreground mb-1">Chismes por Categoría</h3>
        <p className="text-xs text-muted-foreground mb-5">Distribución total</p>
        <CategoryChart />
      </div>
    </div>
  );
}